import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { GuideCardComponent } from '@shared/components/guide-card/guide-card.component';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { FormGroupType } from '@app/core/utils/formgroup-type';
import {
  CreateMeteringPointCommand,
  MeteringGridAreaDto,
  MeteringPointService,
  UpdateMeteringPointCommand
} from '@app/api/dmc';
import { KeyValue } from '@shared/interfaces/key-value/key-value';

@Component({
  selector: 'app-meteringpoint-form-exchange',
  imports: [
    ReactiveFormsModule,
    GuideCardComponent,
    InputGroupComponent,
    LabelDirective,
    SelectDirective,
    TranslatePipe
  ],
  templateUrl: './meteringpoint-form-exchange.component.html',
  styleUrl: './meteringpoint-form-exchange.component.css'
})
export class MeteringpointFormExchangeComponent {
  @Input() public form!: FormGroupType<CreateMeteringPointCommand | UpdateMeteringPointCommand>;

  @Input() public fullWidth: boolean = true;

  /**
   * Grid Area
   */
  public completeGridAreaList: KeyValue[] = [];
  private completeGridArea: MeteringGridAreaDto[] = [];

  constructor(
    private readonly meteringPointService: MeteringPointService,
  ) {
    /**
     * Get all grid areas
     */
    this.meteringPointService.meteringPointGetAllGridAreasGet().subscribe((data: MeteringGridAreaDto[]) => {
      this.completeGridArea = data;
      this.completeGridAreaList = data.map((data: MeteringGridAreaDto) => ({ key: data.id ?? '', value: data.name ?? '' }))
    })
  }

}
